import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import './account.less';
import { fetchLenderAccount, fetchLoan, fetchLoans } from './accountActions';
import { getError, isBusy } from 'actionware';
import Panel from '../../components/panel/panel';
import { Alert, Spin } from 'antd';
import moment from 'moment';
import * as R from 'ramda';
import { dateFormat, moneyFormat } from '../../common/constants';
import * as numeral from 'numeral';
import EachLoanDetail from './eachLoanDetail';

@connect(({ localize, account: { selectedLoanDetails } }) => ({
  translate: getTranslate(localize),
  loading:
    isBusy(fetchLoan) ||
    isBusy(fetchLoans) ||
    isBusy(fetchLenderAccount) ||
    isBusy(fetchLenderAccount) ||
    R.isEmpty(selectedLoanDetails),
  error: getError(fetchLoan),
  selectedLoanDetails
}))

export default class LoanDetails extends PureComponent {
  wrapContent(content) {
    return <Panel className={'loan-details'}>{content}</Panel>;
  }

  renderEachDetail(title,content,style){
    return(
      <div>
        <span>{title}</span>
        <span style={style}>{content}</span>
      </div>
    )
  }

  render() {
    const {
      translate,
      loading,
      error,
      selectedLoanDetails: {
        contractId,
        borrowerType,
        status,
        numberOfInstallment,
        installmentPaid,
        installmentAmount,
        disbursementDate,
        nextRepaymentDate,
        completionDate,
        isOverdue,
        startOverdueDate,
        daysOverdue,
        totalPenalty,
        investmentAmount,
        currentProfit,
        estimateProfit
      }
    } = this.props;

    if (loading) {
      return this.wrapContent(
        <Spin tip={translate('generic.loadingData')} size="large" />
      );
    }

    if (error) {
      return this.wrapContent(
        <Alert
          message={translate('generic.loadingErrorCaption')}
          description={translate('generic.loadingErrorMessage')}
          type="error"
          showIcon
        />
      );
    }

    const statusText = status === 'closed' ? translate('loan.fullyRepaid') : translate('loan.statusActive');
    const nextIntallmentAmountText = numberOfInstallment === installmentPaid ? '---' : installmentAmount;
    const disbursementDateText = disbursementDate !== '' ? moment(disbursementDate).utc().format(dateFormat) : '---';
    const isOverdueText = isOverdue === true ? translate('generic.yes') : translate('generic.no');
    const startOverdueDateText = isOverdue === true ? moment(startOverdueDate.split(' ').reverse().join('-')).utc().format(dateFormat) : '---';
    const daysOverdueText = isOverdue === true ? daysOverdue : '---';
    const totalPenaltyText = isOverdue === true ? translate('generic.amount', {
      value: numeral(totalPenalty).format(moneyFormat)
    }) : '---';

    return this.wrapContent(
      <div>
        <Panel.Section
          className={'details'}
          title={translate('account.loanDetails')}
          subtitle={translate('account.showingLoanInfo', {
            contractId
          })}
        >
          <ul className="detail-list">
            {/*Loan Info*/}
            <li>
              <span className="title">{translate('loan.loanInfo')}</span>
              <div className="wrapper">
                <EachLoanDetail title={translate('loan.borrowerType')} content={borrowerType}/>
                <EachLoanDetail title={translate('loan.status')} content={statusText} styling={status === 'closed' ? {color:'#2bab7b',fontWeight:'bold'} : {color:'#F3AF00',fontWeight:'bold'}}/>
                <EachLoanDetail title={translate('loan.investmentAmount')} content={translate('generic.amount', {
                  value: numeral(investmentAmount).format(moneyFormat)
                })}/>
              </div>
              <hr/>
            </li>
            {/*Profit*/}
            <li>
              <span className="title">{translate('loan.profit')}</span>
              <div className="wrapper">
                <EachLoanDetail title={translate('loan.currentProfit')} content={translate('generic.amount', {
                  value: numeral(currentProfit).format(moneyFormat)
                })}/>
              {
                // only for fully repaid
                status !== 'closed' && <EachLoanDetail title={translate('loan.estimatedLoanProfit')} content={translate('generic.amount', {
                  value: numeral(estimateProfit).format(moneyFormat)
                })} />
              }

              </div>
              <hr/>
            </li>
            {/*Installment*/}
            <li>
              <span className="title">{translate('loan.installment')}</span>
              <div className="wrapper">
                <EachLoanDetail title={translate('loan.numInstallment')} content={numberOfInstallment}/>
                <EachLoanDetail title={translate('loan.numPaidInstallment')} content={installmentPaid}/>
                <EachLoanDetail title={translate('loan.nextInstallmentAmount')} content={translate('generic.amount', {
                  value: numeral(nextIntallmentAmountText).format(moneyFormat)
                })}/>
              </div>
              <hr/>
            </li>
            {/*Date*/}
            <li>
              <span className="title">{translate('loan.date')}</span>
              <div className="wrapper">
                <EachLoanDetail title={translate('loan.disbursementDate')} content={disbursementDateText}/>
                <EachLoanDetail title={translate('loan.nextRepaymentDate')} content={status === 'closed' ? '---' : moment(nextRepaymentDate).utc().format(dateFormat)}/>
                <EachLoanDetail title={translate('loan.estimatedCompleteDate')} content={moment(completionDate).utc().format(dateFormat)}/>
              </div>
              <hr/>
            </li>
            {/*Overdue*/}
            <li>
              <span className="title">{translate('loan.overdue')}</span>
              <div className="wrapper">
                <EachLoanDetail title={translate('loan.overdueStatus')}content={isOverdueText} styling={isOverdue === true ? {color:'red'} : {color:'#2bab7b'}}/>
                <EachLoanDetail title={translate('loan.startOverdueDate')} content={startOverdueDateText}/>
                <EachLoanDetail title={translate('loan.daysOverdue')}content={daysOverdueText}/>
                <EachLoanDetail title={translate('loan.totalPenalty')}content={totalPenaltyText}/>
              </div>
              <hr/>
            </li>
          </ul>
        </Panel.Section>
      </div>
    );
  }
}
